import { defineMessages } from 'react-intl';

export default defineMessages({
    enrollAutopay: {
        id: 'tdic.billing.billing-summary.Enroll in Autopay',
        defaultMessage: 'Enroll in {enrollmentPlan}'
    },
    selectPlan: {
        id: 'tdic.billing.billing-summary.At the top of this screen, please select the policy for which you want to change the payment plan.',
        defaultMessage: 'At the top of this screen, please select the policy for which you want to change the payment plan.{note}: To allow for payment flexibility, you must change {each} policy\'s payment plan separately.'
    },
    setPaymentPlan: {
        id: 'tdic.billing.change-payment-plan.billing-summary.Setup Payment Plan',
        defaultMessage: 'Setup Payment Plan'
    },
    setupAutomaticPayments: {
        id: 'billing.billing-summary.Setup Automatic Payments',
        defaultMessage: 'Setup Automatic Payments'
    },
    enterValidEmailAddressAPW: {
        id: 'billing.billing-summary.Enter a valid email address',
        defaultMessage: 'Enter a valid email address'
    },
    invalidEmailAPW: {
        id: 'billing.billing-summary.Value must be valid email address',
        defaultMessage: 'Value must be valid email address'
    },
    emailFetchError: {
        id: 'billing.billing-summary.emailFetchError',
        defaultMessage: 'Error fetching email address. Please try again.'
    },
    emailUpdateError: {
        id: 'billing.billing-summary.emailUpdateError',
        defaultMessage: 'Error updating email address. Please try again.'
    },
    policyNumberError: {
        id: 'billing.billing-summary.policyNumberError',
        defaultMessage: 'Policy number is required to update email address.'
    },
    emailSubmitSuccess: {
        id: 'billing.billing-summary.emailSubmitSuccess',
        defaultMessage: 'Email address successfully updated.'
    },
    paymentPlan: {
        id: 'billing.billing-summary.Payment Plan',
        defaultMessage: 'Payment Plan'
    },
    submitAPW: {
        id: 'billing.billing-summary.SubmitAPW',
        defaultMessage: 'Submit'
    }
});
